// extracted by mini-css-extract-plugin
export default {"paginatorContainer":"SellerInfo_paginatorContainer__07tSw","line":"SellerInfo_line__DO2MD"};